import { render, staticRenderFns } from "./detailsPurchaser.vue?vue&type=template&id=0f41af4e"
import script from "./detailsPurchaser.vue?vue&type=script&lang=js"
export * from "./detailsPurchaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports